/* eslint-disable semi,semi-style */

/** 
 * 
 * 
 * 这里不用，header 用的是开发中心的 header
 * 

 */
import React, { createContext } from 'react'
// import { Link } from 'react-router-dom'
import { login, logout } from '@/util/login'
import { DownOutlined } from '@ant-design/icons';
import { Menu, Dropdown } from 'antd';
import classNames from 'classnames'
import IconArrow from './down.svg'
import IconUser from './user.svg'
import style from '@/common/scss/header.module.scss'
import { withRouter } from 'react-router-dom'
import HeaderComp from '@/page/developer/components/header';
export default HeaderComp
const navItems = [
  { href: '/', name: '首页' },
  { href: '/developer.html#/', name: '开发中心' },
  { href: '/operate.html#/', name: '运维监控' },
  { href: '/opshare/', name: '运维共享' },
]
const menuList = [
  { path: '/developer.html#/service/insurance', name: '购险服务' },
  { path: '/developer.html#/service/purchase', name: '采购服务' },
]
const menu = (
  <Menu>
    {menuList.map((it, k) => (
      <Menu.Item key={k}>
        <a href={it.path}>{it.name}</a>
      </Menu.Item>
    ))}
  </Menu>
);
const getParents = (node, selector) => {
  const compareNode = document.querySelector(selector)
  const body = document.querySelector('body')
  while (node !== compareNode) {
    node = node.parentNode
    if (node === body) {
      return false
    }
  }
  return true
}

interface companyRole {
  companyId: string;
  roleId: string;
}

export interface UserInfo {
  uid: string;
  duid: string;
  cellphone?: string;
  phone?: string;
  realPhone?: string;
  companyIds: string[];
  companyRoles: companyRole[];
  loginError: boolean;
}

interface HeaderProps {
  user?: UserInfo;
  className?: string;
}

export const UserInfoContext = createContext<UserInfo>(null);

@withRouter
  class Header extends React.Component<HeaderProps> {

  doLogout = () => {
    localStorage.clear();
    location.href = logout()
  }

  doLogin = () => {
    location.href = login()
  }

  toggleMenu = () => {
    const { menu } = this.refs
    menu.style.display = menu.style.display === 'block' ? 'none' : 'block'
  }

  activeEvent = (item) => {
    const { location } = this.props
    const { pathname } = window.location
    console.log(pathname, 'pathname', location)
    if (item.href === '/') {
      return pathname === '/' || pathname === '/index.html'
    }
    // 下拉列表
    if (item.subItem) {
      return location.pathname.indexOf(item.href) !== -1
    }
    if (item.href === '/operate.html#/' && pathname !== '/' && pathname !== '/index.html') {
      if (location.pathname.indexOf('/devops') === -1 && location.pathname.indexOf('/service') === -1) {
        return true
      }
      return false
    }
    return (pathname + '#' + location.pathname).indexOf(item.href) !== -1
  }

  render() {
    const { user, className } = this.props
    return (
      <header className={classNames(style.header, className)}>
        <h1 className={style.logo}>滴滴充电</h1>
        <nav className={style.nav}>
          <ul className={style.navList}>
            {navItems.map((it, i) => (
              <li key={i} className={style.navItem}>
                <a
                  className={classNames(style.navLink, {
                    [style.active]: this.activeEvent(it),
                  })}
                  href={it.href}
                >{it.name}</a>
              </li>
            ))}
            <Dropdown overlay={menu}>
              <li className={style.navItem}>
                <a
                  className={classNames(style.navLink, {
                    [style.active]: this.activeEvent({
                      href: 'service',
                      name: '服务管理',
                      subItem: true,
                    }),
                  })}
                >
                  服务管理 <DownOutlined />
                </a>
              </li>
            </Dropdown>
          </ul>
        </nav>

        <div className={style.loginArea}>
          {/* <a className="btnLink" href={login}>认证</a> */}
          {/* <a className="btnLink" href={login}>注册</a> */}
          {user ?
            <div className={style.layoutUser}>
              <div className={style.selection} onClick={this.toggleMenu}>
                <IconUser className={[style.layoutIcon, style.icon].join(' ')} />
                <span className={style.name}>{user.phone}</span>
                <IconArrow className={style.layoutIcon} />
              </div>
              <div className={style.menu} ref="menu" style={{ display: 'none' }}>
                <span
                  className={style.menuItem}
                  onClick={this.doLogout}
                >
                  退出
                </span>
              </div>
            </div>
            : <a className={[style.btnLink, style.login].join(' ')} onClick={this.doLogin}>登录</a>}
        </div>
      </header>
    );
  }
}